import { useQuery } from '@tanstack/react-query';
import { getV1CompaniesCompanyIdOrdersOrderIdEmailIntakeMessage } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { EmailIntakeMessage } from '~hooks/useEmailIntakeMessages/models';
import connection from '~services/connectionModule';
import { useStores } from '~store';
import { getEffectiveUserCompanyId } from '~utils/user/user-utils';

export default function useOrderEmailIntakeMessageQuery(orderId: string) {
  const { userStore } = useStores();
  const companyId = getEffectiveUserCompanyId(userStore);

  const { data, isError } = useQuery({
    queryKey: ['orderEmailIntakeMessage', companyId, orderId],
    queryFn: async ({ signal }) => {
      try {
        const response = await getV1CompaniesCompanyIdOrdersOrderIdEmailIntakeMessage({
          path: { 'company-id': companyId, 'order-id': orderId },
          signal,
        });

        return EmailIntakeMessage.parse(response.data.data);
      } catch (error) {
        connection.handleRequestError(
          error,
          t('error_messages.email_intake_messages.failed_to_fetch'),
        );
        throw error;
      }
    },
    retry: false,
    staleTime: Infinity,
  });

  return { emailIntakeMessage: data ?? null, isError };
}
